// The classical constellation figures the viewer draws (src/constellations.js)
// and Astronomy mode and the star map prints snap to their catalogue stars:
// (RA hours, Dec degrees) of the bright named stars in each constellation,
// from SIMBAD / the Bright Star Catalog, with each figure's lines as pairs of
// stars to join. Plain data, so pages that only need the figures do not
// bring three.js with them.

export const CONSTELLATIONS = [
  {
    name: 'Orion',
    description: 'The Hunter. Home to Betelgeuse, Rigel, and the Orion Nebula. Visible worldwide in winter.',
    labelRA: 5.60, labelDec: -2.0,
    lines: [
      [5.92,  7.41, 5.42,  6.35],
      [5.92,  7.41, 5.59,  9.93],
      [5.42,  6.35, 5.59,  9.93],
      [5.53, -0.30, 5.60, -1.20],
      [5.60, -1.20, 5.68, -1.94],
      [5.42,  6.35, 5.53, -0.30],
      [5.92,  7.41, 5.68, -1.94],
      [5.53, -0.30, 5.24, -8.20],
      [5.68, -1.94, 5.80, -9.67]
    ]
  },
  {
    name: 'Big Dipper',
    description: 'Asterism within Ursa Major. The two outer bowl stars (Dubhe and Merak) point to Polaris.',
    labelRA: 12.5, labelDec: 56.0,
    lines: [
      [11.06, 61.75, 11.03, 56.38],
      [11.03, 56.38, 11.90, 53.69],
      [11.90, 53.69, 12.26, 57.03],
      [12.26, 57.03, 11.06, 61.75],
      [12.26, 57.03, 12.90, 55.96],
      [12.90, 55.96, 13.40, 54.93],
      [13.40, 54.93, 13.79, 49.31]
    ]
  },
  {
    name: 'Cassiopeia',
    description: 'The Queen on her throne. Distinct W shape opposite Ursa Major across the celestial pole.',
    labelRA: 1.0, labelDec: 62.0,
    lines: [
      [0.15, 59.15, 0.68, 56.54],
      [0.68, 56.54, 0.95, 60.72],
      [0.95, 60.72, 1.43, 60.24],
      [1.43, 60.24, 1.91, 63.67]
    ]
  },
  {
    name: 'Cygnus',
    description: 'The Swan, also known as the Northern Cross. Deneb anchors one corner of the Summer Triangle.',
    labelRA: 20.5, labelDec: 42.0,
    lines: [
      [20.69, 45.28, 20.37, 40.26],
      [20.37, 40.26, 19.52, 27.96],
      [19.75, 45.13, 20.37, 40.26],
      [20.37, 40.26, 20.77, 33.97]
    ]
  },
  {
    name: 'Leo',
    description: 'The Lion. The "sickle" forms the head and mane; Regulus marks the heart.',
    labelRA: 10.5, labelDec: 18.0,
    lines: [
      [10.14, 11.97, 10.33, 19.84],
      [10.33, 19.84, 10.28, 23.42],
      [10.28, 23.42,  9.76, 26.01],
      [10.33, 19.84, 10.13, 23.77],
      [10.33, 19.84, 11.24, 20.52],
      [11.24, 20.52, 11.82, 14.57],
      [11.82, 14.57, 11.24, 15.43],
      [11.24, 15.43, 10.14, 11.97]
    ]
  },
  {
    name: 'Scorpius',
    description: 'The Scorpion. Antares burns red at its heart; the curved tail ends with the stinger Shaula.',
    labelRA: 16.8, labelDec: -28.0,
    lines: [
      [16.00, -22.62, 16.09, -19.81],
      [16.00, -22.62, 16.35, -25.59],
      [16.35, -25.59, 16.49, -26.43],
      [16.49, -26.43, 16.83, -34.29],
      [16.83, -34.29, 17.62, -42.99],
      [17.62, -42.99, 17.79, -37.30],
      [17.79, -37.30, 17.56, -37.10]
    ]
  },
  {
    name: 'Taurus',
    description: 'The Bull. The V-shaped Hyades cluster forms the face; the Pleiades sit just above.',
    labelRA: 4.6, labelDec: 22.0,
    lines: [
      [4.60, 16.51, 4.48, 19.18],
      [4.48, 19.18, 4.39, 17.93],
      [4.39, 17.93, 4.33, 15.96],
      [4.33, 15.96, 4.60, 16.51],
      [4.60, 16.51, 5.44, 28.61],
      [4.48, 19.18, 5.63, 21.14]
    ]
  },
  {
    name: 'Crux',
    description: 'The Southern Cross. Smallest of the 88 constellations and the most iconic of the southern sky.',
    labelRA: 12.5, labelDec: -60.0,
    lines: [
      [12.44, -63.10, 12.52, -57.11],
      [12.79, -59.69, 12.25, -58.75]
    ]
  },
  {
    name: 'Lyra',
    description: 'The Lyre. Vega is the brightest of its stars and a corner of the Summer Triangle.',
    labelRA: 18.85, labelDec: 36.0,
    lines: [
      [18.62, 38.78, 18.75, 37.61],
      [18.75, 37.61, 18.83, 33.36],
      [18.83, 33.36, 18.98, 32.69],
      [18.98, 32.69, 18.91, 36.90],
      [18.91, 36.90, 18.75, 37.61]
    ]
  },
  {
    name: 'Aquila',
    description: 'The Eagle. Altair is its brightest star and the third corner of the Summer Triangle.',
    labelRA: 19.85, labelDec: 8.0,
    lines: [
      [19.77, 10.61, 19.85,  8.87],
      [19.85,  8.87, 19.92,  6.41],
      [19.85,  8.87, 19.10, 13.86],
      [19.85,  8.87, 19.42, -1.06]
    ]
  },
  {
    name: 'Andromeda',
    description: 'The Princess. Mirach points the way to the Andromeda Galaxy (M31), 2.5 million light-years away.',
    labelRA: 1.2, labelDec: 38.0,
    lines: [
      [0.14, 29.09, 0.66, 30.86],
      [0.66, 30.86, 1.16, 35.62],
      [1.16, 35.62, 1.61, 41.41],
      [1.16, 35.62, 0.83, 23.42]
    ]
  },
  {
    name: 'Ursa Minor',
    description: 'The Little Bear. The handle ends at Polaris, the North Star, sitting almost exactly on the pole.',
    labelRA: 15.0, labelDec: 80.0,
    lines: [
      [ 2.53, 89.26, 17.54, 86.59],
      [17.54, 86.59, 16.77, 82.04],
      [16.77, 82.04, 15.74, 77.79],
      [15.74, 77.79, 14.85, 74.16],
      [14.85, 74.16, 15.34, 71.83]
    ]
  },
  {
    name: 'Canis Major',
    description: 'The Greater Dog. Sirius — the brightest star in the night sky — marks its collar.',
    labelRA: 7.0, labelDec: -22.0,
    lines: [
      [6.75, -16.72, 6.38, -17.96],
      [6.75, -16.72, 6.98, -28.97],
      [6.98, -28.97, 7.14, -26.39],
      [7.14, -26.39, 7.40, -29.30],
      [7.40, -29.30, 6.98, -28.97],
      [6.75, -16.72, 7.14, -26.39]
    ]
  },
  {
    name: 'Gemini',
    description: 'The Twins. Castor and Pollux are the heads; their stick-figure bodies stretch toward the Milky Way.',
    labelRA: 7.3, labelDec: 25.0,
    lines: [
      [7.58, 31.89, 6.75, 16.40],
      [7.75, 28.03, 6.63, 16.40],
      [7.58, 31.89, 7.75, 28.03],
      [6.75, 16.40, 6.63, 16.40],
      [7.58, 31.89, 7.43, 27.80],
      [7.43, 27.80, 7.06, 20.57]
    ]
  },
  {
    name: 'Perseus',
    description: 'The Hero, holding the head of Medusa (the variable star Algol). Site of the Perseid meteor shower.',
    labelRA: 3.4, labelDec: 45.0,
    lines: [
      [3.40, 49.86, 3.13, 49.61],
      [3.13, 49.61, 3.08, 53.51],
      [3.40, 49.86, 3.96, 40.96],
      [3.96, 40.96, 3.90, 31.88],
      [3.13, 49.61, 3.08, 40.01],
      [3.40, 49.86, 3.75, 42.58]
    ]
  },
  {
    name: 'Pegasus',
    description: 'The Winged Horse. The Great Square forms its body; one corner is shared with Andromeda.',
    labelRA: 23.0, labelDec: 22.0,
    lines: [
      [23.08, 15.21,  0.22, 15.18],
      [ 0.22, 15.18,  0.14, 29.09],
      [ 0.14, 29.09, 23.08, 28.08],
      [23.08, 28.08, 23.08, 15.21],
      [23.08, 28.08, 22.72, 30.22],
      [22.72, 30.22, 22.10, 25.35]
    ]
  },
  {
    name: 'Bootes',
    description: 'The Herdsman. A kite-shaped figure anchored on Arcturus, the brightest star in the northern sky.',
    labelRA: 14.5, labelDec: 33.0,
    lines: [
      [14.26, 19.18, 14.53, 38.31],
      [14.53, 38.31, 14.69, 27.07],
      [14.69, 27.07, 15.04, 40.39],
      [15.04, 40.39, 15.26, 33.31],
      [15.26, 33.31, 14.53, 38.31],
      [14.69, 27.07, 14.26, 19.18]
    ]
  },
  {
    name: 'Sagittarius',
    description: 'The Archer. Its asterism is "the Teapot" — the spout points to the centre of the Milky Way.',
    labelRA: 18.6, labelDec: -28.0,
    lines: [
      [18.40, -29.83, 18.92, -26.30],
      [18.92, -26.30, 18.96, -29.88],
      [18.96, -29.88, 18.40, -29.83],
      [18.40, -29.83, 18.35, -34.38],
      [18.35, -34.38, 18.96, -29.88],
      [18.92, -26.30, 19.04, -21.74],
      [19.04, -21.74, 18.92, -26.30]
    ]
  },
  {
    name: 'Hercules',
    description: 'The Hero. Contains the globular cluster M13, one of the brightest in the northern sky.',
    labelRA: 17.2, labelDec: 30.0,
    lines: [
      [16.41, 21.49, 17.25, 14.39],
      [17.25, 14.39, 17.51, 26.11],
      [17.51, 26.11, 16.69, 31.60],
      [16.69, 31.60, 16.41, 21.49],
      [17.51, 26.11, 17.93, 37.15],
      [16.69, 31.60, 16.15, 38.92]
    ]
  },
  {
    name: 'Centaurus',
    description: 'The Centaur. Hosts Alpha Centauri, the closest star system to the Sun (4.37 light-years).',
    labelRA: 13.5, labelDec: -45.0,
    lines: [
      [14.66, -60.83, 14.07, -60.37],
      [14.07, -60.37, 13.82, -47.29],
      [13.82, -47.29, 14.11, -36.37],
      [13.82, -47.29, 14.59, -42.10],
      [14.66, -60.83, 13.92, -47.29],
      [13.66, -53.47, 13.07, -49.23]
    ]
  },
  {
    name: 'Virgo',
    description: 'The Maiden. Spica anchors the constellation; the Virgo Cluster lies within its borders.',
    labelRA: 13.0, labelDec: 0.0,
    lines: [
      [13.42, -11.16, 12.93, -1.45],
      [12.93, -1.45, 13.04,  3.40],
      [13.04,  3.40, 12.69, 10.96],
      [12.69, 10.96, 12.33, -0.67],
      [12.33, -0.67, 11.84,  1.76],
      [13.04,  3.40, 13.36, -0.60],
      [13.36, -0.60, 13.42, -11.16]
    ]
  }
];
